import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _DoneRoundLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "m5 14 3.233 2.425a1 1 0 0 0 1.374-.167L18 6" }) }) });
}
const DoneRoundLight = forwardRef(_DoneRoundLight);
export { DoneRoundLight };
